<template>
  <b-modal
    id="destroy-pixel-rule-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
  >
    <div class="text-center mt-3">
      <div class="mb-4">
        <i class="fa fa-warning font-size-large text-warning"></i>
      </div>
      <h2 class="">
        <span>{{ $t('delete_pixel_rule') }}</span>
      </h2>
      <p v-html="$t('are_you_sure_you_want_to_remove_the_pixel_rule', {name: rule ? rule.name : ''})"></p>
      <Button
        type="button"
        class="btn btn-color10 mt-4"
        @click="click"
      >
        {{ $t('remove') }}
      </Button>
    </div>
  </b-modal>
</template>

<script>

import Button from '@/components/common/Button/Button'

export default {
  name: 'DestroyPixelRuleModal',
  props: ['rule'],
  components: {
    Button
  },
  methods: {
    /**
     * Submit
     */
    async click () {
      this.$bvModal.hide('destroy-pixel-rule-modal')
      this.$emit('pixel-rule-destroyed', this.rule)
    }
  }
}
</script>
